module.exports = __webpack_public_path__ + "static/media/jacket-1.96096096.jpg";